
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class DrawerHamburger extends ThemeComponent {
    @Ref hamburgerButton !: HTMLButtonElement;
    @Ref closeButton !: HTMLButtonElement;
    /** Initialise component */
    init() {
        this.menuEvent();
        this.buttonsEvent();
    }

    private menuEvent() {
        this.$listen(this.hamburgerButton, 'click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new Event('openMenu'));
            document.dispatchEvent(new Event('hamburgerOpen'));
        });
        this.$listen(this.closeButton, 'click', (event) => {
            event.preventDefault();
            document.dispatchEvent(new Event('closeMenu'));
            document.dispatchEvent(new Event('hamburgerClose'));
            if (document.body.classList.contains('search-open')) {
                document.dispatchEvent(new Event('searchClose'));
            }
        });
    }

    private buttonsEvent() {
        document.addEventListener('hamburgerOpen', () => {
            this.hamburgerButton.classList.add('visually-hidden');
            this.closeButton.classList.remove('visually-hidden');
        });
        document.addEventListener('hamburgerClose', () => {
            this.hamburgerButton.classList.remove('visually-hidden');
            this.closeButton.classList.add('visually-hidden');
        });
    }
}
